import { createGenericStore } from '@/stores/utils/genericStore.js' // Assumes genericStore.js is in your main app's 'resources/js/utils/'
import axios from 'axios'

// 1. Define your custom options
const TagsStoreOptions = {
  state: () => ({
    attachingTagIds: [],
    detachingTagIds: [],
  }),

  // Custom getters
  getters: {
    isAttachingTag(state) {
      return (tagId) => state.attachingTagIds.includes(Number(tagId))
    },
    isDetachingTag(state) {
      return (tagId) => state.detachingTagIds.includes(Number(tagId))
    },
  },

  // Custom actions
  actions: {
    async attachTag(tagId, taggablePayload) {
      const normalizedTagId = Number(tagId)

      if (!Number.isInteger(normalizedTagId) || normalizedTagId <= 0) {
        throw new Error('A valid tag is required.')
      }

      this.error = null
      this.attachingTagIds.push(normalizedTagId)

      try {
        const { data } = await axios.post(`${this.api}/${normalizedTagId}/attach`, taggablePayload)
        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.attachingTagIds = this.attachingTagIds.filter((id) => id !== normalizedTagId)
      }
    },
    async detachTag(tagId, taggablePayload) {
      const normalizedTagId = Number(tagId)

      if (!Number.isInteger(normalizedTagId) || normalizedTagId <= 0) {
        throw new Error('A valid tag is required.')
      }

      this.error = null
      this.detachingTagIds.push(normalizedTagId)

      try {
        await axios.post(`${this.api}/${normalizedTagId}/detach`, taggablePayload)
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.detachingTagIds = this.detachingTagIds.filter((id) => id !== normalizedTagId)
      }
    },
  }
}

// 2. Create the store hook using your generic factory
export const useTagsStore = createGenericStore(
  'tags', // Base Store ID
  '/api/v1/tags', // API Endpoint
  TagsStoreOptions // Pass in your custom logic
)
